export default function MySub(model, eventBus, subName = "update") {
    this.model = model
    this.eventBus = eventBus
    this.subMap = {}
    this.subName = subName

    let flag = false

    this.updateSub = eventBus.sub(model, subName, (props) => {
        const { data: { eventName } } = props

        const mySubEventCBList = this.subMap[eventName]

        this.subMap[eventName] = []

        mySubEventCBList.forEach(cb => {
            flag = cb(props)
            if (!flag) {
                this.subMap[eventName].push(cb)
            }
        })
    })
}

MySub.prototype.invoke = function (eventName, params) {
    this.model.invoke(eventName, params)
}

// falg:true  监听一次事件
MySub.prototype.sub = function (eventName, cb, { once = true, only = true } = { once: true, only: true }) {
    if (!this.subMap[eventName]) {
        this.subMap[eventName] = []
    }

    const fn = function (props) {
        cb(props)
        return once
    }

    if (only) {
        this.subMap[eventName] = [fn]
    } else {
        this.subMap[eventName].push(fn)
    }
}

MySub.prototype.unsub = function () {
    this.eventBus.unsub(this.updateSub)
}

MySub.prototype.pub = function (props) {
    this.eventBus.pub(this.model, this.subName, props)
}